<template>
  <div class="info">
    <div class="mask" v-if="imagesShow">
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide :key="i" v-for="(item,i) in imageList">
          <div class="swiper-slide-imgbox" @click="closeSwiper">
            <img :src="item.url">
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="header">
      <img src="../assets/banner.jpg?v=4" alt="我们一起在青过年" />
      <div class="mask" v-if="videoMask">
        <div class="mask_back">
          <button @click="videoClose"></button>
        </div>
        <div class="mask_content">
          <video ref="video" id="video" :src="videoboxUrl" controls style="height:100%;width:100%"></video>
        </div>
      </div>
    </div>
    <div class="wrapper">
      <h2 class="cf">
        <span>在青过年故事</span>
      </h2>
      <div class="commentarea" id="commentarea">
        <div class="row">
          <input
            type="text"
            id="ctitle"
            name="ctitle"
            v-model="form.title"
            maxlength="36"
            placeholder="请输入标题（必填）"
            @blur="windowScroll"
          />
        </div>
        <div class="row">
          <textarea name="comment" id="comment" v-model="form.content" placeholder="请输入内容（必填，内容字数不限）" @blur="windowScroll"></textarea>
        </div>
        <div class="row">
          <label class="required">昵称</label>
          <input
            type="text"
            id="nickname"
            name="nickname"
            v-model="form.nickname"
            placeholder="请输入昵称（必填）"
            maxlength="30"
            @blur="windowScroll"
          />
        </div>
        <div class="row">
          <label class="required">联系电话</label>
          <input
            type="text"
            id="tel"
            name="tel"
            v-model="form.mobile"
            placeholder="我们将严格保护您的个人信息（必填）"
            maxlength="19"
            @blur="windowScroll"
          />
        </div>
        <div class="row">
          <label>图片（9张以内、单张大小5M以内）</label>
          <el-upload
            action
            list-type="picture-card"
            :file-list="photoList"
            :on-preview="handlePictureCardPreview"
            :before-upload="beforePictureUpload"
            :http-request="handlePictureUpLoad"
            :on-remove="handleRemove"
            :limit="9"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </div>
        <div class="row">
          <label>视频</label>
          <el-upload
            class="upload-demo"
            action
            :on-preview="handlePreview"
            :on-remove="handleRemoveVideo"
            :http-request="handleVideoUpLoad"
            :before-upload="beforeVideoUpload"
            :file-list="videoList"
            :limit="2"
            list-type="picture-card"
          >
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">只能上传 mp4 文件，且不超过50M，最多2个</div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisibleVideo" @close="closeVideo">
            <video width="100%" :src="dialogVideoUrl" controls="controls"></video>
          </el-dialog>
        </div>
        <div class="row btnrow" style="margin-top: 32px;">
          <a href="javascript:void(0);" class="btnpost" id="postcomm" @click="onSubmit">提交</a>
        </div>
      </div>

      <h2 class="cf">
        <span>故事选登</span>
      </h2>
      <div class="catpost" id="catpost">
        <div class="commlist" id="commlist" ref="commlist">
          <div class="commitem cf" v-for="(item,index) in articleList" :key="index" :label="item">
            <div class="avatar">
              <img v-if="item.is_top == 1" src="../assets/avatar3.png" alt />
              <img v-else src="../assets/avatar.png" alt />
            </div>
            <div class="conbox">
              <div class="cinfo" v-if="item.is_top == 1">{{item.nickname}}：{{item.create_time_text}}</div>
              <div class="cinfo" v-else>网友{{item.nickname}}：{{item.create_time_text}}</div>
              <h3>{{item.title}}</h3>
              <div class="content content_img" v-if="item.works_photo.length > 0">
                <div
                  class="img_cell"
                  :style="{'height': imgHeight + 'px','background-image': 'url('+image.url+')'}"
                  v-for="(image,i) in item.works_photo"
                  :key="i"
                  :label="image"
                  @click="showSwiper(item.works_photo,i)"
                >
                  <!-- <img :src="image.url" /> -->
                </div>
              </div>
              <div class="content content_video" v-if="item.works_video.length > 0">
                <div
                  class="video_cell"
                  v-for="(video,v) in item.works_video"
                  :key="v"
                  :label="video"
                  :style="{'background-image': 'url('+video.url+'?x-oss-process=video/snapshot,t_1000,f_jpg,ar_auto)'}"
                  @click="videoPlay(video.url)"
                >
                  <!-- <video :src="video.url" controls x5-video-player-fullscreen="true"></video> -->
                  <img src="../assets/play.png" />
                </div>
              </div>
              <div class="content textPre" v-if="!item.showAllText">{{item.content}}</div>
              <div class="content ismore" v-else>
                <div class="cinner textPre">{{item.content}}</div>
                <div class="exprow">
                  <a href="javascript:void(0);" class="viewall" @click="showAll(index)">展开全文</a>
                </div>
              </div>
            </div>
            <div class="bangbanReply conbox" v-if="!!item.reply">
              <div class="avatar"></div>
              <div class="conbox">
                <div class="cinfo">帮办回复：</div>
                <div class="content">{{item.reply}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="getmore">
          <a id="btnGetmore" href="javascript:void(0);" v-if="!articleLoaded" @click="loadMore">加载更多</a>
          <p v-else>已经到底，没有更多留言了！</p>
        </div>
      </div>
    </div>
    <div class="footer">
      <p>
        <img style="width: 100px;" src="../assets/bandao.png" alt="半岛都市报" />
        <i class="line"></i>
        <img style="width: 76px;" src="../assets/logo.jpg" alt="半岛新闻" />
      </p>
    </div>
    <div class="masker hide"></div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import OSS from "ali-oss";
import Swiper from 'swiper';
export default {
  name: "info",
  data() {
    return {
      videoMask: false,
      imagesShow: false,
      imageList: [], // 图片展示
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
        },
        initialSlide: 0
      },
      videoboxUrl: "",
      imgHeight: 60, // 列表图片高度
      form: {
        nickname: "",
        mobile: "",
        title: "",
        content: "",
        works_photo: "",
        works_video: ""
      },
      dialogImageUrl: "", // 图片列表放大
      dialogVisible: false, // 预览弹窗
      fileList: [],
      dialogVideoUrl: "",
      dialogVisibleVideo: false, // 视频弹窗
      photoList: [], // 作品图片列表
      videoList: [], // 视频图片列表
      works_photo: [],
      works_video: [],
      share_title: "我们一起在青过年", // 分享标题
      share_desc: "说出你的故事和祝福", // 分享描述
      share_image: "https://bd-config.oss-cn-qingdao.aliyuncs.com/share.png", // 分享缩略图

      articleList: [], // 底部列表
      pageIndex: 1, // 页码
      articleLoaded: false, // 是否已加载全部
      videoFull: false, //视频是否全屏
      imageOrVideo: '',
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  mounted() {
    var _this = this;
    // console.log();
    // 列表图片高度
    _this.imgHeight = (_this.$refs.commlist.clientWidth - 40) / 3;
    // 底部列表
    _this.getArticleList();
    // 分享
    _this.wxshare();
    //监听返回事件
    if (window.history && window.history.pushState) {
      window.addEventListener('popstate', _this.backPage, false);//false阻止默认事件
    }
  },
  methods: {
    /**
     * 返回上一页
     */
    backPage(){
      var _this = this;
      if (_this.imageOrVideo == 1) {
        _this.closeSwiperBack();
      } else if (_this.imageOrVideo == 2) {
        _this.videoBack();
      }
    },
    /**
     * ios键盘不收起问题
     */
    windowScroll(){
      window.scroll(0, 0);
    },
    /**
     * 关闭swiper
     */
    closeSwiper(){
      var _this = this;
      _this.imagesShow = false
      _this.imageList = [];
      _this.swiperOptions.initialSlide = 0;
      window.history.go(-1);
    },
    closeSwiperBack(){
      var _this = this;
      _this.imagesShow = false
      _this.imageList = [];
      _this.swiperOptions.initialSlide = 0;
    },
    /**
     * 展示图片
     */
    showSwiper(imgList,i){
      // console.log(i)
      var _this = this;
      _this.imagesShow = true
      _this.imageList = imgList;
      _this.swiperOptions.initialSlide = i;
      window.history.pushState({status: 0} ,'' ,'?data=1');
      _this.imageOrVideo = 1;
    },
    /**
     * 播放视频
     */
    videoPlay(url) {
      var _this = this;
      _this.videoMask = true;
      _this.videoboxUrl = url;
      window.history.pushState({status: 0} ,'' ,'?data=2');
      _this.imageOrVideo = 2;
      setTimeout(()=>{
        _this.$refs.video.play();
      },900);
    },
    videoClose(){
      var _this = this;
      _this.$refs.video.pause();
      _this.videoMask = false;
      _this.videoboxUrl = "";
      window.history.go(-1);
    },
    videoBack(){
      var _this = this;
      // _this.$refs.video.pause();
      _this.videoboxUrl = "";
      _this.videoMask = false;
    },
    /**
     *  展开全文
     */
    showAll(index) {
      this.articleList[index].showAllText = false;
    },
    /**
     *  获取文章列表
     */
    getArticleList() {
      var _this = this;
      _this.$axios
        .post(_this.url + "/arts2/lists", {
          page: _this.pageIndex
        })
        .then(res => {
          var data = res.data;
          if (data.code == 1) {
            var list = data.data.data;
            for (let i = 0; i < list.length; i++) {
              var item = list[i];
              if (item.content.length <= 42) {
                item.showAllText = false;
              } else {
                item.showAllText = true;
              }
              _this.articleList.push(item);
            }
            if (!list || data.data.is_last_page == 1) {
              _this.articleLoaded = true;
            }
          } else {
            _this.articleLoaded = true;
          }
        })
        .catch(error => {
          console.log(error);
          _this.articleLoaded = true;
        });
    },
    /**
     *  加载更多
     */
    loadMore() {
      this.pageIndex++;
      this.getArticleList();
    },
    /**
     * 手机号验证
     */
    telCheck() {
      var tCheck = /^1\d{10}$|^0\d{2,3}-?\d{7,8}-?\d{0,5}$/,
        _this = this;
      return !tCheck.test(_this.form.mobile);
    },
    /**
     *  表单提交
     */
    onSubmit() {
      var _this = this;
      console.log(_this.form, _this.works_photo, _this.works_video);
      if (_this.form.title.length < 5 || _this.form.title.length > 36) {
        _this.$message.error("请输入5-36字的标题！");
      } else if (
        _this.form.content.length < 10
      ) {
        _this.$message.error("请输入10个字以上的内容！");
      } else if (!_this.form.nickname) {
        _this.$message.error("请输入昵称！");
      } else if (_this.telCheck()) {
        _this.$message.error("请输入正确手机号！");
      } else {
        _this.form.works_photo = JSON.stringify(_this.works_photo);
        _this.form.works_video = JSON.stringify(_this.works_video);
        // _this.form.works_photo = _this.works_photo;
        // console.log('submit!',_this.form);

        _this.$axios
          .post(_this.url + "/arts2/signUp", _this.form)
          .then(res => {
            // console.log(res);
            var result = res.data;
            if (result.code == 1) {
              _this.$message({
                message: result.msg,
                type: "success"
              });

              // 重置
              _this.form.nickname = "";
              _this.form.mobile = "";
              _this.form.title = "";
              _this.form.content = "";
              _this.form.works_photo = "";
              _this.form.works_video = "";
              _this.works_photo = [];
              _this.works_video = [];
              _this.photoList = [];
              _this.videoList = [];
              // 底部列表
              _this.getArticleList();
            } else {
              _this.$message.error("提交失败，" + result.msg);
            }
          })
          .catch(error => {
            console.log(error);
            _this.$message.error("提交失败");
          });
      }
    },

    /**
     *  图片上传
     */
    handleRemove(file, fileList) {
      // console.log(file, fileList);
      var _this = this;
      for (let i = 0; i < _this.photoList.length; i++) {
        const item = _this.photoList[i];
        if (file.url == item.url) {
          _this.photoList.splice(i, 1);
        }
      }
      for (let i = 0; i < _this.works_photo.length; i++) {
        const item = _this.works_photo[i];
        if (file.url == item) {
          _this.works_photo.splice(i, 1);
        }
      }
      // console.log(_this.works_photo);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforePictureUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png" ||
        file.type === ".jpeg" ||
        file.type === ".jpg" ||
        file.type === ".png";
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error("上传图片应为 jpg 或 png 格式!");
        return isJPG;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 5MB!");
        return isLt2M;
      }
    },
    handlePictureUpLoad(file) {
      var _this = this;
      _this.$axios
        .get(_this.url + "/arts2/getUpData", {
          params: {
            type: file.file.type
          }
        })
        .then(res => {
          var data = res.data;
          if (data.code == 1) {
            // console.log(data);
            var point = data.data.dir.lastIndexOf("/"),
              fileName = data.data.dir.substr(point + 1),
              imgUrl = data.data.host + "/" + data.data.dir;
            // console.log(avatarUrl);
            let uploadData = new FormData();
            uploadData.append("OSSAccessKeyId", data.data.accessid);
            uploadData.append("policy", data.data.policy);
            uploadData.append("signature", data.data.signature);
            uploadData.append("key", data.data.dir);
            uploadData.append("success_action_status", 200);
            // uploadData.append("callback", data.data.callback);
            uploadData.append("file", file.file); // file必须放到最后
            const config = {
              headers: { "Content-Type": "multipart/form-data" },
              onUploadProgress: e => {
                if (e.total > 0) {
                  e.percent = (e.loaded / e.total) * 100;
                }
                file.onProgress(e);
              }
            };
            _this.$axios
              .post(data.data.host, uploadData, config)
              .then(res => {
                // console.log(res)
                _this.photoList.push({ url: imgUrl });
                _this.works_photo.push(imgUrl);
              })
              .catch(error => {
                console.log(error);
                _this.$message.error("上传失败");
              });
          } else {
            _this.$message.error(data.msg);
          }
        })
        .catch(error => {
          console.log(error);
          _this.$message.error("上传失败");
        });
    },

    /**
     *  视频上传
     */
    handleRemoveVideo(file, fileList) {
      // this.videoList = [];
      // this.form.works_video = "";
      var _this = this;
      for (let i = 0; i < _this.videoList.length; i++) {
        const item = _this.videoList[i];
        if (file.url == item.url) {
          _this.videoList.splice(i, 1);
        }
      }
      for (let i = 0; i < _this.works_video.length; i++) {
        const item = _this.works_video[i];
        if (file.showUrl == item) {
          _this.works_video.splice(i, 1);
        }
      }
      // console.log(file, fileList);
    },
    handlePreview(file) {
      this.dialogVideoUrl = file.showUrl;
      this.dialogVisibleVideo = true;
    },
    closeVideo() {
      this.dialogVideoUrl = "";
    },
    beforeVideoUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 50;
      const isJPG =
        file.type === "video/mp4" ||
        file.type === ".mp4" ||
        file.type === "video/quicktime" ||
        file.type === "video/mov";

      if (!isJPG) {
        this.$message.error("上传视频应为 mp4 或 mov 格式!");
        return isJPG;
      }
      if (!isLt2M) {
        this.$message.error("上传视频大小不能超过 50MB!");
        return isLt2M;
      }
    },
    handleVideoUpLoad(file) {
      this.avatarLoading = this.$loading({
        lock: true,
        text: "上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      var _this = this;
      _this.$axios
        .get(_this.url + "/arts2/getUpData", {
          params: {
            type: file.file.type
          }
        })
        .then(res => {
          var data = res.data;
          if (data.code == 1) {
            // console.log(data);
            var point = data.data.dir.lastIndexOf("/"),
              fileName = data.data.dir.substr(point + 1),
              videoUrl = data.data.host + "/" + data.data.dir;
            // _this.$message(videoUrl);
            // console.log(avatarUrl);
            let uploadData = new FormData();
            uploadData.append("OSSAccessKeyId", data.data.accessid);
            uploadData.append("policy", data.data.policy);
            uploadData.append("signature", data.data.signature);
            uploadData.append("key", data.data.dir);
            uploadData.append("success_action_status", 200);
            // uploadData.append("callback", data.data.callback);
            uploadData.append("file", file.file); // file必须放到最后
            const config = {
              headers: { "Content-Type": "multipart/form-data" },
              onUploadProgress: e => {
                if (e.total > 0) {
                  e.percent = (e.loaded / e.total) * 100;
                }
                file.onProgress(e);
              }
            };
            _this.$axios
              .post(data.data.host, uploadData, config)
              .then(res => {
                // console.log(res)
                _this.videoList.push({
                  url:
                    videoUrl +
                    "?x-oss-process=video/snapshot,t_1000,f_jpg,ar_auto",
                  showUrl: videoUrl
                });
                _this.works_video.push(videoUrl);
                _this.avatarLoading.close();
              })
              .catch(error => {
                _this.avatarLoading.close();
                console.log(error);
                _this.$message.error("上传失败");
              });
          } else {
            _this.avatarLoading.close();
            console.log(res);
            _this.$message.error(data.msg);
            // _this.$message({message:_this.videoList[0].url,duration:0});
          }
        })
        .catch(error => {
          _this.avatarLoading.close();
          console.log(error);
          _this.$message.error("上传失败");
        });
    },

    /**
     * 分享
     */
    wxshare() {
      var _this = this;
      this.$axios
        .get("https://bandaoapi.bandaoapp.com/wxapi/wxConfig", {
          params: {
            url: encodeURIComponent(window.location.href.split("#")[0])
          }
        })
        .then(res => {
          var msg = res.data;
          if (msg.code != 200) {
            console.log("接口返回非200");
            return;
          }
          wx.config({
            appId: msg.result.appId,
            timestamp: msg.result.timestamp,
            nonceStr: msg.result.noncestr,
            signature: msg.result.signature,
            jsApiList: [
              "updateAppMessageShareData",
              "updateTimelineShareData",
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
              "onMenuShareQQ",
              "onMenuShareWeibo",
              "hideMenuItems",
              "showMenuItems"
            ]
          });
          wx.ready(function() {
            var shareData = {
              title: _this.share_title, // 分享标题
              desc: _this.share_desc, // 分享描述
              link: window.location.href.split("#")[0], // 分享链接
              imgUrl: _this.share_image, // 分享图标
              success: function(res) {}
            };
            wx.updateAppMessageShareData(shareData);
            wx.updateTimelineShareData(shareData);
            wx.onMenuShareAppMessage(shareData);
            wx.onMenuShareTimeline(shareData);
            wx.onMenuShareQQ(shareData);
            wx.onMenuShareWeibo(shareData);
          });
          wx.error(function(error) {
            console.log("error");
            // alert(JSON.stringify(res))
          });
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info_content p {
  margin: 0;
  padding: 0;
}

.info {
  width: 100%;
  position: relative;
  font: 14px/1.5em "PingFang SC", "Source Han Sans CN", "Lantinghei SC",
    "Open Sans", Arial, "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑",
    "STHeiti", "WenQuanYi Micro Hei", SimSun, sans-serif;
  color: #000;
  margin: 0;
  overflow: hidden;
  padding: 0;
}
.info_top {
  width: 100%;
  height: auto;
  display: block;
}
.info_content {
  margin: 4vw 0;
  padding: 0 4vw;
  width: 100%;
}
.info_content {
  line-height: 1.5;
  word-spacing: normal;
  text-align: justify;
  font-size: 15px;
}
.apply_form {
  margin: 4vw 0;
  padding: 0 4vw;
  width: 100%;
}
.el-select {
  width: 100%;
}
.el-form-item {
  margin-bottom: 8px;
}
.pay_code {
  display: block;
  width: 90%;
  height: auto;
  margin: 32px auto;
}
.bottom_p {
  color: #777;
  font-size: 12px;
}

/* globle */
body {
  margin: 0;
}
body {
  font: 14px/1.5em "PingFang SC", "Source Han Sans CN", "Lantinghei SC",
    "Open Sans", Arial, "Hiragino Sans GB", "Microsoft YaHei", "寰蒋闆呴粦",
    "STHeiti", "WenQuanYi Micro Hei", SimSun, sans-serif;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  padding: 0;
}
button,
input,
select,
textarea {
  font-family: "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin: 0;
}
ul {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
h1,
h2,
h3,
h4 {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
}
h2 {
  font-size: 16px;
  font-weight: 400;
  border-bottom: 1px solid #b9b9b9;
  margin-bottom: 10px;
  margin-top: 10px;
}
h2 span {
  float: left;
  padding: 0 6px 5px;
  border-bottom: 2px solid #ff605a;
}
h3 {
  font-size: 14px;
  font-weight: 400;
}
a {
  color: #ccc;
  text-decoration: none;
}
input,
select,
textarea,
button {
  -webkit-appearance: none;
  border-radius: 0;
  border: 1px solid #ccc;
}
.hide {
  display: none !important;
}
.cf:after {
  clear: both;
  content: " ";
  display: block;
  visibility: hidden;
}

/* main */
.header {
  margin: 0;
  padding: 0;
}
.header img {
  width: 100%;
  vertical-align: top;
  margin: 0;
  padding: 0;
  display: block;
}
.wrapper {
  width: 92%;
  margin: 0 4%;
}
.row {
  margin-bottom: 10px;
}
.btnrow {
  text-align: center;
}
.commentarea {
  margin-bottom: 30px;
}
.commentarea textarea {
  padding: 2px 5px;
  width: 100%;
  margin: 0;
  height: 200px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 14px;
}
.commentarea input[type="text"] {
  padding: 4px 5px;
  width: 100%;
  font-size: 14px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.commentarea select {
  width: 100%;
  padding: 4px 5px;
  color: #999;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 14px;
}
.btnpost {
  background-color: #ff605a;
  color: #fff;
  padding: 8px 32px;
}

.tags {
  width: 100%;
  margin-bottom: 20px;
  position: relative;
}
.tags ul {
  width: 100%;
  font-size: 12px;
}
.tags ul li {
  display: inline-block;
  margin-bottom: 10px;
  width: 50%;
}
.tags a {
  color: #7a7a7a;
  background-color: #f1f1f1;
  margin: 0 5px;
  padding: 4px 10px;
  display: block;
  line-height: 20px;
}
.tags .active {
  background-color: #ff605a;
  color: #fff;
}
.catpost {
  clear: both;
}

.commitem {
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
  padding-bottom: 10px;
}
.commitem:after {
  clear: both;
  content: ".";
  display: block;
  width: 0;
  height: 0;
  visibility: hidden;
}

.conbox {
  overflow: hidden;
}

.commitem .avatar {
  float: left;
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.avatar img {
  width: 100%;
  vertical-align: top;
}

.conbox .cinfo {
  font-size: 12px;
  color: #666;
}
.conbox.bangbanReply .cinfo {
  padding-top: 8px;
  color: #000;
}
.conbox h3 {
  margin-bottom: 5px;
}
.conbox .content {
  color: #666;
}
.conbox .content .cinner {
  line-height: 1.6em;
}
.conbox .ismore .cinner {
  overflow: hidden;
  height: 48px;
}
.exprow {
  text-align: right;
}
.viewall {
  display: none;
  color: #999;
  background-color: #fff;
  font-size: 12px;
  border: 1px solid #ccc;
  padding: 0 6px;
}
.ismore .viewall {
  display: inline-block;
}

.loading {
  height: 100px;
  background: transparent
    url("http://image.thepaper.cn/html/zt/2016/12/jianyan/default/img/loading.gif")
    no-repeat center 30px;
  background-size: 30px;
}
.getmore {
  text-align: center;
  color: #b9b9b9;
}
.getmore a {
  color: #b9b9b9;
  background-color: #f0f0f0;
  display: block;
  padding: 8px 0;
}
.getmore p {
  background-color: #f0f0f0;
  padding: 8px 0;
  color: #666;
}

.footer {
  text-align: center;
  padding: 30px 0;
}

/**
 *  在青过年故事
 */
.masker {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 998;
}
.popwrap {
  position: fixed;
  width: 80%;
  left: 5%;
  top: 20%;
  z-index: 999;
  background-color: #fff;
  padding: 5%;
}
.popwrap h2 {
  color: #ff605a;
  font-size: 14px;
  font-weight: 400;
  border-bottom: 1px solid #d9d9d9;
  padding-bottom: 10px;
}
.popwrap .row {
  margin-bottom: 10px;
}
.popwrap .row label {
  color: #4c4c4c;
  float: left;
  width: 20%;
  line-height: 30px;
  text-align: right;
  padding-right: 4%;
}
.popwrap .row input {
  float: left;
  width: 70%;
  font-size: 14px;
  padding: 4px 6px;
  box-sizing: border-box;
  border: 1px solid #ccc;
}
.popwrap .btnrow {
  margin: 0;
}
.popwrap .btnrow button {
  background-color: #ff605a;
  color: #fff;
  width: 100%;
  border: 0 none;
  padding: 6px 0;
  font-size: 14px;
}
.popwrap .verifying input {
  width: 70px;
  float: left;
}
.popwrap .verifying img {
  float: left;
  margin-left: 10px;
}
.popwrap .verifying a {
  line-height: 30px;
  font-size: 14px;
  float: left;
  margin-left: 10px;
  color: #999;
}

.btn-close {
  float: right;
  width: 20px;
  height: 20px;
  background: transparent
    url("http://image.thepaper.cn/html/zt/2016/12/jianyan/default/img/icon-close.jpg")
    no-repeat 0 0;
}

.commentarea .verifying {
  overflow: hidden;
  width: 100%;
}
.commentarea .verifying input {
  width: 40%;
  float: left;
}
.commentarea .verifying img {
  width: 100%;
  height: 100%;
}
.verifying_img {
  width: 86px;
  height: 28px;
  margin: 0 16px;
  float: left;
}
.commentarea .verifying a {
  width: calc(60% - 118px);
  float: left;
}

.footer p {
  display: flex;
  justify-content: center;
  align-items: center;
}
.line {
  display: block;
  height: 30px;
  width: 1px;
  background-color: #ccc;
  margin: 0 16px;
}
.required:after {
  display: inline;
  content: "*";
  color: #ff605a;
}

.content_img,
.content_video {
  zoom: 1;
  margin-bottom: 5px;
}
.content_img:after,
.content_video:after {
  display: block;
  content: "";
  overflow: hidden;
  height: 0;
  clear: both;
}
.img_cell {
  width: 33.333333333%;
  float: left;
  box-sizing: border-box;
  border: 1px solid #fff;
  overflow: hidden;
  position: relative;
  background-size: cover;
  background-position: center;
}
.video_cell {
  width: calc(50% - 2px);
  float: left;
  box-sizing: border-box;
  border: 1px solid #555;
  overflow: hidden;
  height: 90px;
  background-size: cover;
  background-position: center;
  position: relative;
  margin: 1px;
}
.video_cell > img {
  height: 32px;
  width: 32px;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.mask{
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  z-index: 9999;
  overflow: hidden;
}

/*swiper样式*/
.swiper-container{
  height: 100%;
}
.swiper-slide-imgbox{
  width: 100%;
  height: calc(100% - 30px);
  margin: 16px 0;
  overflow: auto;
  position: relative;
}
.swiper-slide-imgbox img{
  width: 100%;
  height: auto;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
  .swiper-wrapper,.swiper-slide{
    height: 100%;
  }
  .swiper-slide{
    padding: 1px 0;
  }

  /* 视频 */
  .mask_back{
    height: 48px;
    width: 100%;
    background: #333;
    border-bottom: 1px solid #222;
  }
  .mask_content{
    height: calc(100% - 48px);
    width: 100%;
  }
  .mask_content > video{
    display: block;
    margin: 0;
    padding: 0;
  }
  .mask_back > button{
    width: 48px;
    height: 100%;
    float: left;
    border: 0;
    background: url(../assets/back.png) center no-repeat;
    background-size: 70%;
    outline: none;
  }
  .textPre{
    white-space: pre-wrap;
  }
</style>
